import { render } from "./PropertyTabs.vue?vue&type=template&id=1767f5f0&ts=true"
import script from "./PropertyTabs.vue?vue&type=script&lang=ts"
export * from "./PropertyTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__